import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../core/shared/classes/api';

@Injectable()
export class TypeTacheService {

    constructor (private apiService: ApiService) {}

    getTypeTache(metier?: String): Observable<ApiResponse> {
        return this.apiService.get('type-tache/' + (metier ? 'metier/' + metier : '') );
    }

    getTypeTacheById(id: any): Observable<ApiResponse> {
        return this.apiService.post('type-tache/' + id);
    }

    insertTypeTache(data: any): Observable<ApiResponse> {
        return this.apiService.post('type-tache', data);
    }

    updateTypeTache(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('type-tache/' + id, data);
    }

    deleteTypeTache(id: string): Observable<ApiResponse> {
        return this.apiService.delete('type-tache/' + id);
    }
}
